import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'phaseOfFlight'
})
export class PhaseOfFlightPipe implements PipeTransform {

  transform(value: string | null | undefined): unknown {
    switch (value) {
      case 'APPROACH':
        return 'Approach';
      case 'CLIMB':
        return 'Climb';
      case 'CRUISE':
        return 'Cruise';
      case 'DESCENT':
        return 'Descent';
      case 'LANDING':
        return 'Landing';
      case 'NA':
        return 'N/A';
      case 'POST-FLIGHT':
        return 'Post-Flight';
      case 'PRE-FLIGHT':
        return 'Pre-Flight';
      case 'TAKEOFF':
        return 'Takeoff';
      case 'TAXI_IN':
        return 'Taxi-In';
      case 'TAXI_OUT':
        return 'Taxi-Out';
      case 'UNKNOWN':
        return 'Unknown';
      case 'NULL_RECORD':
        return '- Null -';
      case '':
        return '- Null -';
      case null:
        return '- Null -';
      default:
        return value;
    }
  }

}
